// Copyright (c) Docugami, Inc. All rights reserved.

import { Point } from "sdv/Types";

export function clamp(value: number, min: number, max: number): number {
    return Math.min(Math.max(value, min), max);
}

export function modFloor(a: number, n: number) {
    return ((a % n) + n) % n;
}

export function getDistanceBetweenPoints(p1: Point, p2: Point) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}

export function getDistanceSquaredBetweenPoints(p1: Point, p2: Point) {
    return Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2);
}

export const inRangeInclusive = (value: number, start: number, end: number) => value >= start && value <= end;

export const rangesOverlap = (a: number, b: number, c: number, d: number) => Math.max(a, c) < Math.min(b, d);

export function lerpValue(a: number, b: number, t: number) {
    t = clamp(t, 0, 1);
    return (1 - t) * a + t * b;
}

export const minutesToMilliseconds = (minutes: number) => 1000 * 60 * minutes
